import { useParams } from 'react-router-dom';
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container'
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading'
import { useContext, useEffect, useState } from 'react';
import { IconName } from '../../../../shared/interfaces/icon-picker.model';
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications';
import { ICapitalGood } from '../../../../shared/services/capital-good/capital-good.model';
import { GoodForm } from '../../../presentation-components/organisation-components/good/good-form';
import CapitalGoodService from '../../../../shared/services/capital-good/capital-good-service';
import SuperAdminService from '../../../../shared/services/super-admin/super-admin.service';

export const SuperAdminGoodPage = () => {
  const { id } = useParams();
  //Services
  const capitalGoodService = new CapitalGoodService()
  const superAdminService = new SuperAdminService()
  const userNotificationsContext = useContext(UserNotificationsContext)
  //State
  const [good, setGood] = useState<ICapitalGood>();
  const [editField, setEditField] = useState<string>('')
  const [errorMessage, setErrorMessage] = useState<string>()
  const [errorCode, setErrorCode] = useState<number>()
  const [categories, setCategories] = useState<any>()
  //Loading State
  const [isFormSubmitting, setIsFormSubitting] = useState<boolean>(false)

  useEffect(() => {
    if (id) {
      getGood(id)
    }
  }, [id])


  const getGood = (id: string) => {
    capitalGoodService.getOne(id)
      .then(response => {
        setGood(response)
        setCategories(response.goodCategory)
      })
      .catch(err => {
        console.log(err)
      })
  }

  const submitHandler = async (formData: FormData) => {
    if (id && formData) {
      if (!isFormSubmitting) {
        setIsFormSubitting(true)
        superAdminService.updateGood(id, formData)
          .then(response => {
            getGood(response.id!)
            setEditField('')
            userNotificationsContext.openSnackbar({ open: true, message: 'Updated successfully' });
            setIsFormSubitting(false)
          })
          .catch(err => {
            if (err.response.data.message) {
              setErrorMessage(err.response.data.message)
              setErrorCode(err.response.data.code)
            } else {
              userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
            }
            setIsFormSubitting(false)
            console.log(err)
          })
      }
    }
  }

  const activateHandler = (id: string) => {
    userNotificationsContext.openDialog({
      active: true,
      title: 'Confirmation',
      message: `By activating this product, it will be available to be used by all organisations.`,
      buttonCopy: 'Continue', cancelButtonCopy: 'Cancel'
    })
      .then(response => {
        if (response) {
          if (!isFormSubmitting) {
            setIsFormSubitting(true)
            superAdminService.activateGood(id)
              .then(response => {
                getGood(id)
                userNotificationsContext.openSnackbar({ open: true, message: 'Updated successfully' });
                setIsFormSubitting(false)
              })
              .catch(err => {
                userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
                console.log(err)
                setIsFormSubitting(false)
              })
          }
        }
      })
  }

  return (
    <PageOuterContainer>
      {good &&
        <>
          <PageHeading
            title={good.name}
            includeBackButton={true}
            backButtonLink='/super-admin/products'
            backButtonText={`Back to global products`}
            hasTabs={false}
            includeActionButton={true}
            actionButtonIcon={IconName.CheckCircle}
            actionButtonHandler={() => activateHandler(good.id)}
            actionButtonText={'Activate'}
            hideShowActionButton={good.active}
          />
          {good &&
            <GoodForm
              categories={categories}
              isEditPage={true}
              editField={editField}
              setEditField={setEditField}
              onSubmit={submitHandler}
              isSubmitting={isFormSubmitting}
              newGood={good}
              goodActive={good.active}
              errorMessage={errorMessage}
              errorCode={errorCode}
              superAdmin={true}
            />}
        </>}
    </PageOuterContainer>
  )
}